import produce from 'immer';
import moment from 'moment';
import { IAsset, IAssetState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { getSorting, getStatusId, stableSort } from '../../utilities/utilities';
import { IAssetActions } from '../actions/assetActions';
export const initialAssetState: IAssetState = {
  assetIds: [],
  assetMap: {},
  isFetching: false,
  selectedAssets: [],
  fetchCount: 0,
  lastFetched: undefined
};

const processAsset = (asset: any, index: number): IAsset => {
  return {
    id: asset.ID,
    assetId: asset.asset_id,
    state: asset.state ? asset.state : '',
    type: asset.type ? asset.type : '',
    mediaType: asset.media_type,
    feeds: asset.feeds,
    customer: asset.customer,
    sentinelId: asset.sentinel_id,
    status: asset.skynet_status ? asset.skynet_status : '',
    issueTrackerId: asset.issue_tracker_ticket
      ? asset.issue_tracker_ticket.issue_id
      : '',
    issueTrackerStatus: asset.issue_tracker_ticket
      ? asset.issue_tracker_ticket.status
      : '',
    action:
      asset.issue_tracker_ticket && asset.issue_tracker_ticket.issue_id
        ? asset.issue_tracker_ticket.status === 'close'
          ? 'resolved'
          : 'escalated'
        : 'escalate',
    createdAt: asset.created_at,
    stateErrorMessage: asset.state_error_message
      ? asset.state_error_message
      : '',
    updatedAt: asset.updated_at,
    isChecked: false,
    endSnoozeAt: asset.end_snooze_at ? asset.end_snooze_at : 0,
    srNo: index,
    statusId: asset.statusId,
    stateHistory: asset.history
      ? asset.history.map(h => {
          return {
            time_stamp: h.time_stamp ? h.time_stamp : '',
            info: h.info ? h.info : {},
            change: h.change ? h.change : '',
            actor: h.actor ? h.actor : ''
          };
        })
      : [],
    title: asset.title
  };
};

const assetReducer = (
  state = initialAssetState,
  action: IAssetActions
): IAssetState => {
  const assetIds: string[] = [];
  const assetMap: { [key: string]: IAsset } = {}; // asset id to asset json map
  return produce(state, draft => {
    switch (action.type) {
      case actionTypes.FETCH_ASSETS_SUCCESS:
        draft.isFetching = false;
        // sort the asset based on status
        // #workaround : not the most efficient way of sorting
        action.payload = action.payload.map(asset => {
          return { ...asset, statusId: getStatusId(asset.skynet_status) };
        });
        action.payload = stableSort(
          action.payload,
          getSorting('desc', 'statusId')
        );
        action.payload.map((asset: any, index: number) => {
          assetMap[asset.ID] = processAsset(asset, index);
          assetIds.push(asset.ID);
        });

        draft.assetMap = { ...assetMap };
        draft.assetIds = [...assetIds];
        draft.selectedAssets = draft.selectedAssets.filter(
          (assetId: string) => draft.assetIds.indexOf(assetId) !== -1
        );
        draft.lastFetched = moment().format('HH:mm:ss');
        break;
      case actionTypes.FETCH_ASSETS_PENDING:
        draft.fetchCount += 1;
        draft.isFetching = true;
        break;
      case actionTypes.TOGGLE_SELECTED_ASSETS:
        action.assets.map((assetId: string) => {
          const idx = draft.selectedAssets.indexOf(assetId);
          if (idx !== -1) {
            draft.selectedAssets.splice(idx, 1);
          } else {
            draft.selectedAssets.push(assetId);
          }
        });
        break;
      case actionTypes.UPDATE_ASSET:
        for (const asset of action.payload) {
          const assetId = asset.ID;
          draft.assetMap[assetId] = processAsset(
            asset,
            draft.assetMap[assetId].srNo
          );
        }
        break;
      case actionTypes.SNOOZE_ASSETS:
        draft.selectedAssets = [];
        draft.fetchCount = 0;
        break;
      case actionTypes.RESOLVE_ASSET:
        draft.selectedAssets = [];
        draft.fetchCount = 0;
        break;
      case actionTypes.ESCALATE_ASSETS:
        draft.selectedAssets = [];
        draft.fetchCount = 0;
        break;
      case actionTypes.FLUSH_ASSETS:
        draft.selectedAssets = [];
        break;
      case actionTypes.RESET_FETCH_COUNT:
        draft.fetchCount = 0;
        break;
      case actionTypes.FETCH_ASSETS_REJECTED:
        draft.assetIds = [];
        draft.assetMap = {};
        draft.isFetching = false;
        draft.selectedAssets = [];
        draft.fetchCount = 0;
        draft.lastFetched = undefined;
        break;
    }
  });
};

export default assetReducer;
